import { render, staticRenderFns } from "./RateTypeKey.vue?vue&type=template&id=5ca4af56&"
import script from "./RateTypeKey.vue?vue&type=script&lang=js&"
export * from "./RateTypeKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca4af56')) {
      api.createRecord('5ca4af56', component.options)
    } else {
      api.reload('5ca4af56', component.options)
    }
    module.hot.accept("./RateTypeKey.vue?vue&type=template&id=5ca4af56&", function () {
      api.rerender('5ca4af56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RateTypeKey.vue"
export default component.exports